import gql from "graphql-tag";

const EVENT_AND_STAKEHOLDERS_QUERY = gql`
query EventDetails($eventId: String!){
    event(eventId: $eventId){
        Active
        Cancelled
        ChapterId
        EventLookupId
        EventStartDate
        EventStartTime
        EventEndDate
        EventEndTime
        EventName
        EventCategory
        EventType
        CancelledDate
        CancelledComment
        ProjectionEventRevenue
        ProjectionMerchandiseCosts
        ProjectionEventIncome
        ProjectionMajorDonorPayments
        ProjectionEventBaseIncome
        ProjectionNumberOfTransactions
        ProjectionComments
        EventReportEventRevenue
        EventReportMerchandiseCosts
        EventReportEventIncome
        EventReportMajorDonorPayments
        EventReportEventBaseIncome
        EventReportNumberOfTransactions
        EventReportComments
        FinancialStatus
        FinancialTicketSalesNet
        FinancialTicketSalesExpense
        FinancialTicketArrangementsExpense
        FinancialTicketSalesNet
        FinancialMembershipIncome
        FinancialMembershipNet
        FinancialRaffleAndGamesIncome
        FinancialRaffleAndGamesExpense
        FinancialRaffleAndGamesNet
        FinancialLiveAuctionIncome
        FinancialLiveAuctionExpense
        FinancialLiveAuctionNet
        FinancialSilentAuctionIncome
        FinancialSilentAuctionExpense
        FinancialSilentAuctionNet
        FinancialMiscellaneousIncome1
        FinancialMiscellaneousIncome2
        FinancialFinancialAdjustmentExpense
        FinancialCashUnderwriting
        FinancialGrossIncome
        FinancialSubtotalExpense
        FinancialNetProceeds
        FinancialRetainedIncomeExpense
        FinancialRetainedIncomeWithheldExpense
    }
    stakeholders(eventId:$eventId) {
      name
      email
      constituentId
      role
      lookupId
    }
}`

export default EVENT_AND_STAKEHOLDERS_QUERY;